module.exports = __webpack_public_path__ + "img/Taiwan.149d88aa.png";